export default "__VITE_ASSET__BIbiFuyJ__"